// shared/MarketplaceHeader.jsx
// Used by FastMaxLanding (route "/")
// "Soy Tienda" is a Link that navigates to /tienda

import React from "react";
import { Link } from "react-router-dom";
import { Search, Store, ChevronRight } from "lucide-react";
import { brand } from "./brand";

export function MarketplaceHeader() {
  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-slate-100 shadow-sm">
      <nav className="mx-auto max-w-7xl px-4 h-14 flex items-center justify-between gap-3">

        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <img
            src={`${process.env.PUBLIC_URL}/logo.png`}
            alt="FAST MAX"
            className="h-7 w-auto"
          />
          <span
            className="hidden sm:inline text-base font-extrabold italic tracking-wide"
            style={{ color: brand.primary }}
          >
            FAST MAX
          </span>
        </Link>

        {/* Soy Tienda → goes to /tienda */}
        <Link
          to="/tienda"
          className="flex items-center gap-1.5 rounded-xl px-3 py-1.5 text-xs font-semibold border transition-all duration-200 hover:bg-slate-50"
          style={{ background: "white", color: brand.primary, borderColor: brand.primary }}
        >
          <Store className="size-3.5" />
          <span>Soy Tienda</span>
        </Link>

        {/* Right: Search + Auth */}
        <div className="flex items-center gap-2 shrink-0">
          <Link
            to="/buscar"
            className="grid place-items-center size-8 rounded-xl border border-slate-200 bg-white hover:bg-slate-50 transition-colors"
            aria-label="Buscar"
          >
            <Search className="size-4 text-slate-500" />
          </Link>

          <Link
            to="/register"
            className="hidden sm:inline-flex items-center rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-50 whitespace-nowrap transition-colors"
          >
            Crear cuenta
          </Link>

          <Link
            to="/login"
            className="inline-flex items-center gap-1 rounded-xl px-3 py-1.5 text-xs font-semibold text-white whitespace-nowrap"
            style={{ background: brand.primary }}
          >
            
            Iniciar sesión
            <ChevronRight className="size-3.5" />
          </Link>
        </div>
      </nav>
    </header>
  );
}